import LinkExternalIcon from "@redotech/redo-icons/link-external-02.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { RECLAIM_INSTALL_APP_MODAL_UI_SELECTOR } from "./constants";
import * as css from "./reclaim-install-app-modal.module.css";

const RECLAIM_PROMPT_IMAGE_URL =
  "https://redoapi-dev.s3.us-east-1.amazonaws.com/redo/static/onboarding-v2/shopify-image.webp";

export const ReclaimInstallAppModal = memo(function ReclaimInstallAppModal({
  deferPending,
  onDefer,
  onOpenListing,
}: {
  deferPending: boolean;
  onDefer: () => void;
  onOpenListing: () => void;
}) {
  return (
    <RedoModal
      className={css.modal}
      hideFooter
      hideHeader
      isOpen
      modalSize="md"
      muiClassName={css.backdropBlur}
      noPadding
      onModalCloseRequested={ignoreModalClose}
      title="Finish connecting Reclaim in Shopify"
      uiSelector={RECLAIM_INSTALL_APP_MODAL_UI_SELECTOR}
    >
      <Flex className={css.frame} dir="row" gap="none" w="full">
        <Flex
          basis="205px"
          bgColor="secondary"
          bottomLeftRadius="2xl"
          className={css.imagePane}
          overflow="hidden"
          position="relative"
          shrink={0}
          topLeftRadius="2xl"
        >
          <img
            alt=""
            aria-hidden
            className={css.image}
            src={RECLAIM_PROMPT_IMAGE_URL}
          />
        </Flex>

        <Flex
          aria-label="Finish connecting Reclaim in Shopify"
          as="section"
          basis="calc(100% - 191px)"
          bgColor="primary"
          className={css.contentCard}
          dir="column"
          gap="xl"
          p="3xl"
          radius="2xl"
          shadow="lg"
          shrink={0}
        >
          <Flex dir="column" flex={1} gap="xl" justify="space-between">
            <Flex dir="column" gap="sm">
              <Text
                as="h2"
                data-testid="reclaim-install-app-modal-title"
                fontSize="xl"
                fontWeight="semibold"
                textColor="primary"
              >
                Finish connecting Reclaim in Shopify
              </Text>
              <Text fontSize="sm" textColor="secondary">
                Reclaim now uses a dedicated Shopify app connection. Finish this
                step to keep your existing chargeback automation aligned with
                Shopify.
                <br />
                <br />
                You'll continue using the same Redo platform, dashboard,
                workflows, and settings.{" "}
                <Text as="span" fontSize="sm" fontWeight="semibold">
                  Your current setup won't change.
                </Text>
              </Text>
            </Flex>

            <Flex align="center" gap="sm" justify="flex-end" w="full">
              <RedoButton
                hierarchy="secondary"
                onClick={onDefer}
                pending={deferPending}
                size="sm"
                text="Remind me later"
              />
              <RedoButton
                hierarchy="primary"
                IconLeading={LinkExternalIcon}
                onClick={onOpenListing}
                size="sm"
                text="Continue"
              />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </RedoModal>
  );
});

function ignoreModalClose(): void {
  // Intentional no-op: this prompt should only defer from "Remind me later".
}
